export function verif(rows, month, AN) {

  var formeDate = ((month < 10 ? '0' : '') + month + '.' + AN.toString()).toString();

  var array = [];
  var colDesignation = 0;
  var colCode = 0;
  var colPrix = 0;
  var head = false;
  var test = false;

  for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {

    const row = rows[rowIndex];
    const lowercaseRow = row.map(val => val.toString().toLowerCase());

    if (!head && lowercaseRow.includes("drug_product_b") && lowercaseRow.includes("dp_code_b") && lowercaseRow.includes(formeDate)) {
      colDesignation = lowercaseRow.indexOf("drug_product_b");
      colCode = lowercaseRow.indexOf("dp_code_b");
      colPrix = lowercaseRow.indexOf(formeDate);
      head = true;
      test = true;
      continue;
    }

    const code = row[colCode];
    const designation = row[colDesignation]


    //typeof row[colCode] === 'string'  && && row[colCode].startsWith("PF")&& !row[colCode].endsWith("H") && !row[colCode].endsWith("A")
    console.log(typeof row[colCode])


    if (
      (typeof row[colCode] === 'string' && !row[colCode].endsWith("H") && !row[colCode].endsWith("A")) ||
      (typeof row[colCode] === 'number' && !isNaN(row[colCode]))
    ) {
      array.push({
        designation: designation,
        idProduit: null,
        code: code,
        prix: row[colPrix] === undefined ? 0 : row[colPrix],
      });
    }
  }

  // console.log(array)

  return { array: array, test: test };
}








// export function verif(rows) {

//   console.log(rows)


//   var array = [];
//   var colDesignation = 0;
//   var colCode = 0;
//   var colPrix = 0;

//   for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {

//     const row = rows[rowIndex];

//     row.forEach((val, index) => {
//       // console.log(val)
//       const lowerVal = val.toString().toLowerCase();
//       if (lowerVal.includes("designation")) {
//         colDesignation = index;
//       } else if (lowerVal.includes("code")) {
//         colCode = index;
//       }else if (lowerVal.includes("p.u ht - gr") ) {
//         colPrix = index;
//       }
//     });



//     array.push({
//       designation: row[colDesignation],
//       idProduit: null,
//       code: row[colCode],
//       prix: row[colPrix] === undefined ? 0 : row[colPrix],
//     });
//   }

//   return array;
// }


